import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Outlet } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import FullScreenDialog from '../FullScreenDialog';

type UsersDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

const UsersDialog = ({ isOpen, onClose }: UsersDialogProps) => {
  const classes = useStyles();

  return (
    <FullScreenDialog
      contentClassName={classes.dialogContent}
      isOpen={isOpen}
      title="Users"
      onClose={onClose}
    >
      <Outlet />
    </FullScreenDialog>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    position: 'relative',
    background: theme.palette.common.white,
    color: theme.palette.text.primary,
  },
  toolbar: {
    padding: 0,
  },
  dialogContent: {
    backgroundColor: theme.palette.background.default,
  },
}));

export default UsersDialog;